import React from "react";
import { Button, Card, Form, Row, Col } from "react-bootstrap";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import RangeCredit from "../../components/Game/Addons";
import storage from "utils/Storage";
import { gameCoin } from "actions/gameCoin";
import { setWallet } from "actions/gameWallet";
import { isMobile, Event, wait, isValidNumber, forceSatoshiFormat, __, sendNotfication, playAudio } from 'utils/Helper';
import C from 'utils/Constant';
import { FiAlertCircle } from "react-icons/fi";

class Bet extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      engine: this.props.engine,
      bet: "manual",
      buttonText: "Roll",
      started: false,
      isLogged: storage.getKey("logged") !== null ? true : false,
      amount: forceSatoshiFormat(
        storage.getKey("lam") ? storage.getKey("lam") : 50.00
      ),
      disabled: false,
      type: "low",
      betNumber: 10,
      firstBetNumber: 10,
      onWin: 0,
      onLost: 0,
      stopOnWin: 0,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.wrapperRef = React.createRef();
  }

  componentWillUnmount() {
    let { engine, started } = this.state;
    engine.init = false;
    this._isMounted = false;

    try {
      if (started) {
        document.getElementById("bet").click();
      }
    } catch (e) {}
  }

  componentDidMount() {
    let { engine } = this.state;
    this._isMounted = true;
    this.props.gameCoin();
    engine.on(C.BUSTED_DIAMOND, (data) => this.busted(data));
    engine.on(C.ERROR_DIAMOND, (data) => this.error(data));
    engine.on("stop_diamond", () => this.stopAuto());
    engine.on("stop_playing", () => this.stopManual());

    if (isMobile()) {
      this.setState({ mt: "mt-2" });
    }
  }

  stopManual() {
    this.setState({ started: false, buttonText: "Roll", disabled: false });
  }

  stopAuto() {
    if (this._isMounted) {
      this.setState({
        started: false,
        buttonText: "Start Auto Mode",
        disabled: false,
      });
    }
  }

  error(data) {
    if (this._isMounted) {
      sendNotfication(data.message, "info", "top-center");

      if (data.code === "credit") this.props.setWallet(true, data.uid);

      this.setState({ disabled: false });

      if (this.state.started) {
        this.setState({ started: false, buttonText: "Start Auto Mode" });
      }
    }
  }

  busted(data) {
    if (this._isMounted) {
      let { engine, bet, started } = this.state;

      let isWin = false;

      if (parseFloat(data.profit) !== 0) {
        isWin = true;
      }

      if (bet === "auto") {
        if (started) {
          wait(1100).then(() => {
            engine.isWin = isWin;
            engine.roundProfit =
              __.toNumber(data.profit) + __.toNumber(engine.roundProfit);
            this.placeAutoBet();
          });
        }
      }

      wait(1000).then(() => {
        this.setState({ disabled: false });
      });

      wait(500).then(() => {
        if (isWin) {
          playAudio("win.mp3");
        } else {
          // playAudio('lost.mp3');
        }
      });
    }
  }
  handleBet = (e) => {
    // Call setBet to handle the betting logic
    this.setBet(e);
  };

  setBet(e) {
    if (this._isMounted) {
      e.preventDefault();

      let self = this;

      let { isLogged, amount, bet, started } = this.state;

      // Check User
      if (!isLogged) {
        return Event.emit("showAuthModal", true);
      }

      this.setState({ disabled: true });

      if (parseFloat(amount) <= 0) {
        this.setState({ amount: forceSatoshiFormat(50.00) });
      } else {
        amount = Math.min(
          parseFloat(storage.getKey("credit")),
          parseFloat(amount)
        );
        this.setState({ amount: forceSatoshiFormat(amount) });
      }

      if (bet === "auto") {
        if (started) {
          this.setState({
            started: false,
            buttonText: "Start Auto Mode",
            disabled: false,
          });
          return false;
        } else {
          this.setState({ started: true, buttonText: "Stop Auto Mode" });
          this.placeAutoBet();
        }
      } else {
        this.placeBet();
      }
    }
  }

  placeAutoBet() {
    if (this._isMounted) {
      let {
        engine,
        amount,
        type,
        betNumber,
        firstBetNumber,
        onWin,
        onLost,
        stopOnWin,
      } = this.state;
      wait(500).then(() => {
        engine.init = true;
        engine.amount = amount;
        engine.type = type;
        engine.coin = this.props.coin;
        engine.betNumber = firstBetNumber;
        engine.stopOnWin = parseInt(stopOnWin);
        engine.onWin = parseInt(onWin);
        engine.onLost = parseInt(onLost);
        engine.autoStart();
        this.setState({ betNumber: betNumber - 1 });
      });
    }
  }

  placeBet() {
    if (this._isMounted) {
      let { amount, engine } = this.state;

      wait(100).then(() => {
        engine.game = "diamond";
        engine.init = true;
        engine.amount = amount;
        engine.coin = this.props.coin;
        engine.start();
      });
    }
  }

  handleChange = (value) => {
    this.setState({ type: value });
  };

  handleInputChange(event) {
    let target = event.target;
    let value = target.value;

    if (target.name === "amount" || target.name === "stopOnWin") {
      this.setState({ amount: value });
      if (!isValidNumber(value)) return;
    }

    if (target.name === "amount") {
      storage.setKey("lam", value);
    } else {
      this.setState({ [target.name]: value });
    }
  }

  betMode = (type) => {
    let text;

    if (type === "auto") {
      text = "Start Auto Mode";
    } else {
      text = "Roll";
    }
    this.setState({ bet: type, buttonText: text });
  };

  setAmount = (val) => {
    var am = forceSatoshiFormat(val);
    this.setState({ amount: am });
    storage.setKey("lam", am);
  };

  setNumber = (e, num) => {
    e.preventDefault();
    this.setState({ betNumber: num });
    this.setState({ firstBetNumber: num });
  };

  render() {
    let { disabled, amount, bet, type, started, mt } = this.state;
    return (
      <>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            if (this.props.coin === "INR") {
              if (this.state.amount < 100) {
                sendNotfication("Enter valid amount");
              } else {
                this.handleBet(e);
              }
            } else if (this.props.coin === "USDT") {
              if (this.state.amount < 2) {
                sendNotfication("Enter valid amount");
              } else {
                this.handleBet(e);
              }
            } else {
              this.handleBet(e);
            }
          }}
        >
          <Row className={"mt-1"} style={{ padding: "5px 15px" }}>
            {/* header button */}

            <div
              className="bet-option game-fonts"
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-around",
                padding: "2px 7px",
                textAlign: "center",
                alignItems: "center",
                justifyItems: "center",
                margin: "0px 4p",
              }}
            >
              {/* Manual */}
              <div
                className="btn-group btn-group-toggle my-1 ml-1"
                data-toggle="buttons"
                style={{
                  borderRadius: "2rem",
                  padding: "12px 45px",
                  backgroundColor: bet === "manual" ? "#222328" : "transparent",
                  cursor: "pointer",
                  fontSize: "14px",
                  color: bet === "manual" ? "white" : "gray",
                  border: bet === "manual" ? "" : "1px solid transparent",
                }}
                onClick={() => this.betMode("manual")}
              >
                Manual
              </div>

              {/* Auto */}
              <div
                style={{
                  borderRadius: "2rem",
                  padding: "12px 45px",
                  backgroundColor: bet === "auto" ? "#222328" : "transparent",
                  cursor: "pointer",
                  fontSize: "14px",
                  color: bet === "auto" ? "white" : "gray",
                  border: bet === "auto" ? "" : "1px solid transparent",
                }}
                onClick={() => this.betMode("auto")}
              >
                Auto
              </div>
            </div>
            <Col xl={12} md={12} sm={12}>
              <div className="form-group mb-1">
                <div
                  style={{
                    color: "gray",
                    fontSize: "15px",
                    padding: "2px",
                    marginLeft: "12px",
                    justifyItems: "center",
                    alignItems: "center",
                  }}
                  className="game-fonts"
                >
                  Amount
                  <span
                    style={{
                      padding: "0px 3px",
                      color: "#3d9d0c",
                      fontSize: "15px", // Increase the icon size if needed
                      fontWeight: "bold", // Attempt to bolden icon by scaling
                      //   display: 'inline-flex',
                      alignItems: "center",
                    }}
                  >
                    <FiAlertCircle style={{ strokeWidth: 3 }} />{" "}
                    {/* Increase strokeWidth for a bolder look */}
                  </span>
                </div>
                <div className="input-group">
                  <div className="input-group-append input-radius-left">
                    <span
                      className="input-group-text "
                      style={{
                        borderRadius: "2rem 0 0 10px",
                        backgroundColor: "#222328",
                      }}
                    >
                      <img
                        src={"/assets/images/" + this.props.coin + ".png"}
                        className={"mini-coin-7"}
                        alt=""
                      />
                      {/* BET */}
                    </span>
                  </div>
                  <input
                    disabled={disabled}
                    type="text"
                    id="amount"
                    name="amount"
                    placeholder="Enter Bet Amount"
                    value={amount}
                    autoComplete={"off"}
                    onKeyUp={this.handleInputChange}
                    onChange={this.handleInputChange}
                    className="form-control text-left"
                    required={true}
                    style={{
                      borderRadius: "0 0px 0px 0", // Rounded right side of the input field
                      paddingLeft: "0px", // Optional: Ensure the padding inside the input is well spaced
                      backgroundColor: "#222328",
                    }}
                  />
                  <div className="input-group-append">
                    <RangeCredit set={this.setAmount} />
                  </div>
                </div>
              </div>
            </Col>
            <Col xl={12} md={12} sm={12}>
              <div className={"form-group mb-1 bet-input"}>
                <div
                  style={{
                    color: "gray",
                    fontSize: "15px",
                    padding: "2px",
                    marginLeft: "12px",
                    justifyItems: "center",
                    alignItems: "center",
                  }}
                  className="game-fonts"
                >
                  Win Amount
                </div>
                <div className="input-group">
                  <div className="input-group-append input-radius-left">
                    <span
                      className="input-group-text"
                      style={{
                        borderRadius: "2rem 0 0 10px",
                        backgroundColor: "#222328",
                      }}
                    >
                      <img
                        src={"/assets/images/" + this.props.coin + ".png"}
                        className={"mini-coin-7"}
                        alt=""
                      />
                      {/* WIN AMOUNT */}
                    </span>
                  </div>
                  <input
                    type="text"
                    disabled={true}
                    className="form-control"
                    value={forceSatoshiFormat(this.state.amount / 3)}
                    style={{
                      borderRadius: "0 0px 0px 0", // Rounded right side of the input field
                      paddingLeft: "0px", // Optional: Ensure the padding inside the input is well spaced
                      backgroundColor: "#222328",
                      borderTopRightRadius: "20px",
                      borderBottomRightRadius: "20px",
                    }}
                  />
                </div>
              </div>
            </Col>
          </Row>
          <div>
            <span style={{ fontSize: 11, marginLeft: 12 }}>
              {this.props.coin === "INR"
                ? "(Minimum Bet - 100 INR)"
                : "(Minimum Bet - 2 USDT)"}
            </span>
          </div>
          <Row style={{ padding: "0px 15px" }}>
            <Col md={12} sm={12} className="m-auto">
              {bet === "manual" && (
                <div className={"form-group rev mt-2 mb-0"}>
                  <Button
                    variant={"btn btn-block btn-bet btn-xl mb-2"}
                    id={"bet"}
                    disabled={disabled}
                    type="submit"
                    style={{
                      // border: "2px solid red",
                      color: "#fff",
                      boxShadow:
                        "0px 0px 12px rgba(35, 238, 136, 0.3), 0px -2px rgb(29, 202, 106) inset",

                      // backgroundColor: "rgb(67, 179, 9)",
                      backgroundImage:
                        "linear-gradient(90deg, rgb(36, 238, 137), rgb(159, 232, 113))",
                      borderRadius: "10px",
                    }}
                  >
                    {this.state.buttonText}
                  </Button>
                </div>
              )}
            </Col>
          </Row>
          {bet === "auto" && (
            <>
              <Row className="mt-1" style={{ padding: "0px 15px" }}>
                <Col xl={12} md={12} sm={12}>
                  <div className={"form-group mb-1 bet-input"}>
                    <div
                      style={{
                        color: "gray",
                        fontSize: "15px",
                        padding: "2px",
                        marginLeft: "12px",
                        justifyItems: "center",
                        alignItems: "center",
                      }}
                      className="game-fonts"
                    >
                      Number of Bets
                    </div>
                    <div className="input-group">
                      <div className="input-group-append">
                        {/* <span className="input-group-text">
                                                    Bets Num
                                                </span> */}
                      </div>
                      <input
                        style={{
                          backgroundColor: "#222328",
                          borderTopLeftRadius: "20px",
                          borderBottomLeftRadius: "20px",
                        }}
                        type="number"
                        disabled={disabled}
                        className="form-control"
                        required={true}
                        value={this.state.betNumber}
                        onChange={(e) => this.setNumber(e, e.target.value)}
                      />
                      <div className="input-group-append ">
                        <button
                          onClick={(e) => this.setNumber(e, 10)}
                          className={"btn btn-s-4 btn-xs"}
                          style={{ backgroundColor: "#31343c" }}
                        >
                          10
                        </button>
                        <button
                          onClick={(e) => this.setNumber(e, 50)}
                          className={"btn btn-s-4 btn-xs"}
                          style={{ backgroundColor: "#31343c" }}
                        >
                          50
                        </button>
                        <button
                          onClick={(e) => this.setNumber(e, 100)}
                          className={"btn btn-s-4 btn-xs input-radius-right"}
                          style={{ backgroundColor: "#31343c" }}
                        >
                          100
                        </button>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xl={12} md={12} sm={12}>
                  <div className={"form-group mb-1 bet-input"}>
                    <div
                      style={{
                        color: "gray",
                        fontSize: "15px",
                        padding: "2px",
                        marginLeft: "12px",
                        justifyItems: "center",
                        alignItems: "center",
                      }}
                      className="game-fonts"
                    >
                      Increase Amount On Win
                    </div>
                    <div className="input-group">
                      <div className="input-group-append">
                        {/* <span className="input-group-text">
                                                    Increase Amount On Win
                                                </span> */}
                      </div>
                      <input
                        style={{
                          backgroundColor: "#222328",
                          borderTopLeftRadius: "20px",
                          borderBottomLeftRadius: "20px",
                        }}
                        disabled={disabled}
                        type="number"
                        className="form-control"
                        name="onWin"
                        min="0"
                        max="100"
                        autoComplete={"off"}
                        value={this.state.onWin}
                        onChange={(e) =>
                          this.setState({ onWin: e.target.value })
                        }
                      />
                      <div className="input-group-append ">
                        <button
                          className="btn input-radius-right bg-cs2 after-text no-hover npt nh"
                          type="button"
                          style={{ backgroundColor: "#31343c" }}
                        >
                          %
                        </button>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xl={12} md={12} sm={12}>
                  <div className={"form-group mb-1 bet-input"}>
                    <div
                      style={{
                        color: "gray",
                        fontSize: "15px",
                        padding: "2px",
                        marginLeft: "12px",
                        justifyItems: "center",
                        alignItems: "center",
                      }}
                      className="game-fonts"
                    >
                      Increase Amount On Lost
                    </div>
                    <div className="input-group">
                      <div className="input-group-append">
                        {/* <span className="input-group-text">
                                                    Increase Amount On Lost
                                                </span> */}
                      </div>
                      <input
                        style={{
                          backgroundColor: "#222328",
                          borderTopLeftRadius: "20px",
                          borderBottomLeftRadius: "20px",
                        }}
                        disabled={disabled}
                        type="number"
                        className="form-control"
                        name="onLost"
                        min="0"
                        max="100"
                        autoComplete={"off"}
                        value={this.state.onLost}
                        onChange={(e) =>
                          this.setState({ onLost: e.target.value })
                        }
                      />
                      <div className="input-group-append">
                        <button
                          className="btn input-radius-right bg-cs2 after-text no-hover npt nh"
                          type="button"
                          style={{ backgroundColor: "#31343c" }}
                        >
                          %
                        </button>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xl={12} md={12} sm={12}>
                  <div className={"form-group mb-1 bet-input"}>
                    <div
                      style={{
                        color: "gray",
                        fontSize: "15px",
                        padding: "2px",
                        marginLeft: "12px",
                        justifyItems: "center",
                        alignItems: "center",
                      }}
                      className="game-fonts"
                    >
                      Stop On Win
                    </div>
                    <div className="input-group">
                      <div className="input-group-append">
                        {/* <span className="input-group-text">
                                                    Stop On Win
                                                </span> */}
                      </div>
                      <input
                        style={{
                          backgroundColor: "#222328",
                          borderTopLeftRadius: "20px",
                          borderBottomLeftRadius: "20px",
                        }}
                        disabled={disabled}
                        type="text"
                        placeholder=".."
                        className="form-control"
                        name="stopOnWin"
                        value={this.state.stopOnWin}
                        autoComplete={"off"}
                        onChange={this.handleInputChange}
                      />
                      <div className="input-group-append ">
                        <div
                          className="input-group-text input-radius-right "
                          style={{ backgroundColor: "#31343c" }}
                        >
                          <img
                            src={"/assets/images/" + this.props.coin + ".png"}
                            className={"mini-coin-2 mr-1 "}
                            alt=""
                          />
                          {this.props.coin}
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row style={{ padding: "5px 15px" }}>
                <Col sm={12} className={"m-auto"}>
                  <div className={"form-group mt-0 mb-0 rev"}>
                    <Button
                      variant={"btn btn-md btn-block my-2 btn-bet"}
                      type="submit"
                      style={{
                        // border: "2px solid red",
                        color: "#fff",
                        boxShadow:
                          "0px 0px 12px rgba(35, 238, 136, 0.3), 0px -2px rgb(29, 202, 106) inset",

                        // backgroundColor: "rgb(67, 179, 9)",
                        backgroundImage:
                          "linear-gradient(90deg, rgb(36, 238, 137), rgb(159, 232, 113))",
                        borderRadius: "10px",
                      }}
                    >
                      {this.state.buttonText}
                      {started && (
                        <>
                          <div
                            className={"ml-2 spinner-border spinner-border-sm"}
                          />
                        </>
                      )}
                    </Button>
                  </div>
                </Col>
              </Row>
            </>
          )}
          {/* manually option */}
          <div
            className="plingo-option mt-2 game-fonts"
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-around",
              //  padding: "2px 5px",
              textAlign: "center",
              alignItems: "center",
              justifyItems: "center",
              margin: "0px 0px",

              //    border:"2px solid yellow",
              borderTop: "1px solid #222328",
            }}
          >
            {/* Manual */}
            {/* <div
                                    style={{
                                        borderRadius: "2rem",
                                     
                                        padding: "12px 45px",
                                        // borderBottom:bet === 'manual'?'2px solid red':'transparent',
                                        backgroundColor: bet === 'manual' ? '#222328' : 'transparent',
                                        cursor: "pointer",
                                        fontSize: "14px",
                                        color: bet === 'manual' ? 'white' : 'gray',
                                        border: bet === 'manual' ? '' : '1px solid transparent',
                                        // border:"2px solid red"
                                    }}
                                    onClick={() => this.betMode('manual')}
                                >
                                    Manual
                                </div> */}

            {/* Manual */}
            <div
              className={`manual-button ${bet === "manual" ? "active" : ""}`}
              onClick={() => this.betMode("manual")}
            >
              Manual
              {/* <span className="arrow-icon">→</span> */}
            </div>

            {/* Auto */}
            {/* <div
                                    style={{
                                        borderRadius: "2rem",
                                        width:"100%",
                                        padding: "12px 45px",
                                        backgroundColor: bet === 'auto' ? '#222328' : 'transparent',
                                        cursor: "pointer",
                                        fontSize: "14px",
                                        color: bet === 'auto' ? 'white' : 'gray',
                                        border: bet === 'auto' ? '' : '1px solid transparent'
                                    }}
                                    onClick={() => this.betMode('auto')}
                                >
                                    Auto
                                </div> */}

            {/* Auto */}
            <div
              className={`auto-button ${bet === "auto" ? "active" : ""}`}
              onClick={() => this.betMode("auto")}
            >
              Auto
              {/* <span className="arrow-icon">→</span> */}
            </div>
          </div>
        </Form>

        {/* <div className="btn-group btn-group-toggle mb-1 ml-1" data-toggle="buttons">
                    <label className={'' + bet === 'manual' ? 'btn bg-cs2 btn-xs active' : 'btn bg-cs2 btn-xs '}>
                        <input disabled={disabled} onClick={e => this.betMode('manual')} type="radio" /> Manual
                    </label>
                    <label className={'' + bet === 'auto' ? 'btn bg-cs2 btn-xs active' : 'btn bg-cs2 btn-xs '}>
                        <input disabled={disabled} onClick={e => this.betMode('auto')} type="radio" /> Auto
                    </label>
                </div> */}
      </>
    );
  }
}

Bet.propTypes = {
  coin: PropTypes.string,
  credit: PropTypes.string,
};

const mapStateToProps = (state) => ({
  coin: state.items.coin,
  credit: state.items.credit,
});

export default connect(mapStateToProps, { gameCoin, setWallet })(Bet);
